module.exports = __webpack_public_path__ + "img/603781.eb56c1c1.svg";